import React, { useCallback, useEffect, useState } from "react";
import Layout from "../../Components/Layout";
import ProGrid from "../../Components/ProGrid/v2";
import useColumn from "../../../utils/customHooks/useColumns";
import usePageState from "../../../utils/customHooks/usePageState";
import { STAUTES } from "../../../utils/constant";
import { getApi, postApi } from "../../../utils/services";
import { GET_ALL_EMPLOYEE_TIME_ALLOCATION, GET_EMPLOYEE_WPS_ALLOCATION_SETTING } from "../../../utils/services/apiPath";
import { useTranslation } from "react-i18next";
import { errorToast } from "../../../utils/toastHelper";
import { useSelector } from "react-redux";
import { loginSelector } from "../../store/features/auth/authSlice";
import NameCell from "../../Components/ProGrid/components/NameCell";
import DailyTimeAllocationFormModal from "../../Components/ModuleComponent/wps/DailyTimeAllocationFormModal";
import { dateColumnDef } from "../../Components/ProGrid/components/FormatCell";
import { createODataQuery } from "../../../utils/services/oData";

export default function DailyTimeAllocation() {
  const { user } = useSelector(loginSelector) || {};
  const { employeeId } = user;
  const { t } = useTranslation();
  const [showTimeAllocationModal, setShowTimeAllocationModal] = useState(false);
  const [actionData, setActionData] = useState(null);
  const [mounted, setMounted] = useState(false);
  const { projectEmployeeIsMentor: isMentor } = user || {};
  const [canEmployeeAddWps, setCanEmployeeAddWps] = useState(false);
  const showApprovalButton = isMentor && canEmployeeAddWps;
  const allowEdit = isMentor !== canEmployeeAddWps;

  const {
    currentPage,
    pageSize,
    data: wpsTimeData,
    rowCount,
    status,
    sortModel,
    searchString,
    setPageState,
    setPagination,
    setStatus,
    setSortModel,
    setSearchString
  } = usePageState();

  const openTimeAllocationModal = params => {
    setActionData(params.row);
    setShowTimeAllocationModal(true);
  };

  const columns = useColumn([
    {
      field: "employeeName",
      headerName: "ApprenticeName"
    },
    dateColumnDef({
      field: "workDate",
      headerName: "WorkDate",
      renderCell: params => <NameCell params={params} onClick={openTimeAllocationModal} getRedirectUrl={() => ""} />
    }),
    {
      field: "projectName",
      headerName: "ProjectName"
    },
    {
      field: "estimatedHours",
      headerName: "estimatedHours"
    },
    {
      field: "otjHours",
      headerName: "OTJHoursLabel"
    },
    {
      field: "wpsStatus",
      headerName: "Status"
    }
  ]);

  const getWpsTimeAllocationList = useCallback(async () => {
    setStatus(STAUTES.LOADING);  
    const searchableFields = ["employeeName", "projectName", "wpsStatus"];
    const query = createODataQuery(searchableFields, [], "", searchString, sortModel, pageSize, currentPage);
    const queryUrl = `${GET_ALL_EMPLOYEE_TIME_ALLOCATION}${query}&employeeId=${employeeId}&employeeType=${isMentor ? "Mentor" : "Apprentice"}`;
    const response = await getApi(queryUrl);
    setStatus(STAUTES.IDLE);
    if (response?.error) return errorToast(response.error);
    const rows = response?.value || [];
    const totalRecords = response?.["@odata.count"] ?? rows.length;
    setPageState(prevPageInfo => ({ ...prevPageInfo, data: rows.map(row => ({ ...row, id: row.projectApprenticeMentorId, employeeId: row.employeeId, workDate: row.workDate })),     
    rowCount: totalRecords }));
  }, [currentPage, pageSize, sortModel, searchString, setPageState, setStatus, employeeId, isMentor]);

  const getWpsSetting = useCallback(async () => {
    const { data } = await getApi(GET_EMPLOYEE_WPS_ALLOCATION_SETTING, { employeeId });
    setCanEmployeeAddWps(data?.isApprenticeAllowed);
    setMounted(true);
  }, []);

  const handleClose = refresh => {
    setShowTimeAllocationModal(false);
    setActionData(null);
    if (refresh) getWpsTimeAllocationList();
  };

  useEffect(() => {
    if (mounted) getWpsTimeAllocationList();
  }, [getWpsTimeAllocationList, mounted, currentPage, pageSize, searchString]);

  useEffect(() => {
    getWpsSetting();
  }, []);

  return (
    <>
      <Layout>
        <ProGrid
          title={t("WPSTimeAllocation")}
          columns={columns}
          loading={status === STAUTES.LOADING}
          rows={wpsTimeData}
          searchMode={!!searchString}
          searchModel={{ defaultValue: searchString, handleDebounce: setSearchString }}
          hideAddButton={true}
          options={{
            getRowId: row => row.projectApprenticeMentorId,
            rowCount: rowCount,
            paginationMode: "server",
            paginationModel: { pageSize: pageSize, page: currentPage },
            onPaginationModelChange: setPagination,
            sortingMode: "server",
            onSortModelChange: setSortModel
          }}
        />
      </Layout>
      <DailyTimeAllocationFormModal
        show={showTimeAllocationModal}
        handleClose={handleClose}
        actionData={actionData}
        employeeId={employeeId}
        allowEdit={allowEdit}
        showApprovalButton={showApprovalButton}
      />
    </>
  );
}
